import { render, staticRenderFns } from "./AutorizacaoPortabilidadeList.vue?vue&type=template&id=e720250a&lang=true&"
import script from "./AutorizacaoPortabilidadeList.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoPortabilidadeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports